/**
 * 返回 [ min, max ] 之间的整数
 * @param min 包含的最小值
 * @param max 包含的最大值
 */
export function randomNum(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export enum token {
  number = '0123456789',
  lowercase = 'abcdefghijklmnopqrstuvwxyz',
  uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXY',
  alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXY',
  all = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
  enhance = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ~!@#$%^&*()-_=+[]{}|<>?'
}

/**
 * 返回随机字符串
 * @param length 字符串长度
 * @param tokens 字符串词库，未传入值时默认 number + alphabet
 */
export function randomStr(length: number, tokens: token | string = token.all) {
  return [...Array(length)]
    .map(() => tokens[randomNum(0, tokens.length)])
    .join('')
}

const _G = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)

export const Guid = {
  NewGuid: () =>
    [2, 1, 1, 1, 3]
      .map(i => new Array(i).fill(''))
      .map(a => a.map(_G).join(''))
      .join('-')
      .toUpperCase(),
  _G
}
